import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
   SiteDesignFileUpload,
} from 'admin/views/site-designer/modules/sections/modules';
import {
   OptionsButton,
} from 'admin/views/site-designer/modules';
import {
   DESIGN_IMAGE_AWS_PATH,
} from 'admin/views/site-designer/data';
import RadioLabel from 'common/components/elements/inputs/radio-label';
import Icon from 'common/components/elements/icons';
import Button from 'common/components/elements/buttons/primary';
import Convert from 'common/utils/convert-svg-to-png'
import CustomizeLogoModal from 'admin/views/site-designer/modules/sections/customize-logo-modal'
import {
   siteColorsSelector,
} from 'admin/state/modules/site-designer/selectors';
import {
   siteInfoSelector,
} from 'admin/state/modules/common/selectors';
import { useSelector } from 'react-redux';
import { faviconImageUpload, getObjectUrl } from 'admin/api/AuthApi';
import toast from 'common/utils/toast';
import Loader from 'common/components/elements/loader/circle';
import { setDevaultIcon } from 'admin/views/site-designer/data';


const LogoSection = ({
   name,
   value,
   onChange,
   logoType,
}) => {

   const elementRef = useRef(null);
   const [imgvalue, seTimgvalue] = useState('')

   const [fontList, setFontList] = useState([]);
   const [isLoadingFavicon, setIsLoadingFavicon] = useState(false);
   const [loadingFont, setLoadingFont] = useState(true);
   const [isOpenCustomizeModal, setIsOpenCustomizeModal] = useState(false);
   const colors = useSelector(siteColorsSelector)
   const siteInfo = useSelector(siteInfoSelector)
   const siteName = siteInfo.site_long_name;
   const onChangeLogo = (key, v, anyData = {}) => {
      onChange(name, {
         ...value,
         [key]: v,
         ...anyData,
      })
   }

   const onLoadFont = () => {
      setLoadingFont(true)
      const text = siteName?.charAt(0).toUpperCase() + siteName?.slice(1)
      Convert.getGoogleFonts(text, (data) => {
         setFontList(data)
         setLoadingFont(false)
      })
   }

   async function saveLogo(svg, type, settings, width, height){
      svg.setAttribute('width', width)
      svg.setAttribute('height', height)
      const url = await Convert.convertSvgToBase64(svg);
      onChangeLogo('type', 'text', {
         text_data: settings,
         image_full_src: url,
      })
      setIsOpenCustomizeModal(false)
   }


   async function onUploadNew(e) {
      const file = e.target.files[0];
      const type = file ? file.type : '';

      let validFormats = ['image/png'];
      const result = await validLogoSize(file)
      let error = null

      if(!validFormats.includes(type) && !result) {
         error = 'App icon must be in PNG format and must be 1024X1024'
      } else if(!validFormats.includes(type)) {
         error = 'App icon must be in PNG format'
      } else if(!result) {
         error = 'App icon must be 1024x1024 pixels'
      }
      if(error) {
         toast.error(error)
         return
      }

      setIsLoadingFavicon(true)

      const reader = new FileReader();
      reader.onload = function(event) {
         const formData = new FormData();
         formData.append('file', file)
         formData.append('type', 'custom')
         formData.append('bgColor', null)


         uploadNew(formData)

      };
      reader.readAsDataURL(file);
   }

   const uploadNew = async (siteData) => {
      try {

         const { data } = await faviconImageUpload(siteData)
         const pathSrc = `${ data?.path }-app-icon-1024x1024.png`;
         const fullpathData = await getObjectUrl([pathSrc], DESIGN_IMAGE_AWS_PATH);
         onChangeLogo('type', 'image', {
            image_src: data.path,
            image_full_src: fullpathData?.data?.[pathSrc],
         });
         setIsLoadingFavicon(false);

         // const { data: splashFullpath } = await getObjectUrl(`design/images/${ data?.path }-apple-splash-screen-1125x2436.png`)

         // changeNewData({
         //    ...newData,
         //    app_icon_mode: 'image-logo',
         //    app_icon: data.path,
         //    favicon: fullpath?.[0],
         //    apple_splash_screen: splashFullpath?.[0],
         //    isCustomizebleFavicon: false,
         // })

         // toster.success('Your change has been saved!')

      } catch (error) {
         console.log(error);
      } finally {
         // setIsLoadingFavicon(false)
      }
   }

   const validLogoSize = (file) => {
      return new Promise(resolve => {
         var reader = new FileReader();
         reader.readAsDataURL(file);
         reader.onload =  function(e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function() {
               var height = this.height;
               var width = this.width;
               const result = height === 1024 && width === 1024
               return resolve(result)
            };
         }
      });
   }


   async function onClickRevert(mode){

      setIsLoadingFavicon(true)

      let svg = null;
      let settings = null;
      let width = 1024;
      let height = 1024;
      let shortText = siteName.charAt(0).toUpperCase()
      const textData = value.text_data;
      if(textData) {
         shortText = textData.text || siteName.charAt(0).toUpperCase();
      }
      let longText = siteName.charAt(0).toUpperCase() + siteName.slice(1);
      if('main' === mode) {
         settings = textData;
         if(!textData) {
            settings = setDevaultIcon('main').settings
         }
         svg = Convert.logoSvgMaket(settings, longText);
         let logoSvg = document.getElementById('add-remove-main-logo-svg')
         logoSvg.appendChild(svg)
         height = 56
         width = logoSvg.querySelectorAll('text')[0].getBoundingClientRect().width
         svg.setAttribute('width', settings.width || width)
         svg.setAttribute('height', height)
         logoSvg.removeChild(svg)
      } else {
         settings = textData;
         if(!textData) {
            settings = setDevaultIcon('icon').settings
         }
         svg = Convert.faviconSvgMaket(settings, shortText);
      }
      const url = await Convert.convertSvgToBase64(svg)
      onChangeLogo('type', 'text', {
         text_data: settings,
         image_full_src: url,
      })
      setIsLoadingFavicon(false)
   }



   if('app_icon' === logoType){

      return (
         <div className='flex flex-col gap-4'>
            <div className='flex items-center justify-center w-14 h-14 border rounded-lg bg-panel'>
               {
                  isLoadingFavicon && (
                     <Loader
                        size={ 6 }
                     />
                  )
               }
               {
                  !isLoadingFavicon && value?.image_full_src && (
                     <img src={ value.image_full_src } alt='app_icon_and_favicon' className=' object-cover object-center w-full h-full' />
                  )
               }

            </div>
            <div className='flex justify-between w-full'>
               <input
                  type='file'
                  onChange={ (e) => {
                     onUploadNew(e)
                     seTimgvalue('')
                  } }
                  hidden
                  value={ imgvalue }
                  accept='image/png,image/jpeg,image/png'
                  ref={ elementRef }
               />
               <OptionsButton
                  iconName='upload'
                  fontColor='secondary'
                  text='Upload now'
                  onClick={ (e) =>  elementRef.current.click() }
                  disabled={ isLoadingFavicon }
                  textSize='small'
               />
               <OptionsButton
                  iconName={ 'text' === value.type ? 'customize' : 'revert' }
                  fontColor='secondary'
                  text={ 'text' === value.type ? 'Customize' : 'Revert to default' }
                  onClick={ async (e) => {
                     if('text' === value.type){
                        setIsOpenCustomizeModal(true)
                        if(fontList.length === 0) {
                           onLoadFont()
                        }
                        return;
                     }
                     onClickRevert();

                  } }
                  disabled={ isLoadingFavicon }
                  textSize='small'
               />
               {
                  isOpenCustomizeModal && (
                     <CustomizeLogoModal
                        fontList={ fontList }
                        onClose={ () => setIsOpenCustomizeModal(false) }
                        saveCustomImg={ saveLogo }
                        data={ {
                           ...value.text_data,
                           text: value.text_data.text || siteName.slice(0, 3),
                        } }
                        siteName={ siteName }
                        colors={ colors }
                        loadingFont={ loadingFont }
                     />
                  )
               }
            </div>
         </div>
      )
   }
   return (
      <div className='flex flex-col gap-4'>
         <div className='flex flex-col py-1 rounded-lg border border-divider w-full bg-panel'>
            <LogoSectionRadioItem
               onChange={ _ => onChangeLogo('type', 'text') }
               checked={ 'text' === value?.type }
               id={ `${ name }_text_type` }
               title='Text'
               iconName='text'
            />
            <LogoSectionRadioItem
               onChange={ _ => onChangeLogo('type', 'image') }
               checked={ 'image' === value?.type }
               id={ `${ name }_image_type` }
               title='Image'
               iconName='image'
            />
         </div>
         {
            'text' === value?.type  && (
               <div className='inline-flex max-w-[187px]'>
                  <Button
                     text='Customize logo'
                     textSize='base'
                     backgroundColor='transparent'
                     primaryColor={ false }
                     textColor='secondary'
                     iconName='customize'
                     fontIconColor='secondary'
                     iconPosition='left'
                     onClick={ () => {
                        setIsOpenCustomizeModal(true)
                        if(fontList.length === 0) {
                           onLoadFont()
                        }
                     } }
                  />
               </div>
            )
         }
         {
            'image' === value?.type  && (
               <div className='inline-flex w-full h-[184px]'>
                  <SiteDesignFileUpload
                     onChange={ (src = null, image_full_src = null) => {
                        onChange(name, {
                           ...value,
                           image_src: src,
                           image_full_src: image_full_src,
                        })
                     } }
                     src={ value.src }
                     fullSrc={ value.image_full_src }
                  />
               </div>
            )
         }
         {
            isOpenCustomizeModal && (
               <CustomizeLogoModal
                  type='main'
                  fontList={ fontList }
                  onClose={ () => setIsOpenCustomizeModal(false) }
                  saveCustomImg={ saveLogo }
                  data={ value.text_data }
                  siteName={ siteName }
                  colors={ colors }
                  loadingFont={ loadingFont }
               />
            )
         }
      </div>

   )
}

const LogoSectionRadioItem = ({
   onChange,
   checked,
   id,
   title,
   iconName,
}) => {
   return (
      <RadioLabel
         id={ id }
         checked={ checked }
         onChange={ onChange }
         className='h-10'
      >
         <div className='flex gap-3 items-center'>
            <div className='flex items-center justify-center w-5 h-5'>
               <Icon
                  size='lg'
                  color='secondary'
                  name={ iconName }
               />
            </div>
            <span>{title}</span>

         </div>
      </RadioLabel>
   )
}

LogoSectionRadioItem.propTypes = {
   onChange: PropTypes.func,
   checked: PropTypes.bool,
   id: PropTypes.string,
   title: PropTypes.string,
   iconName: PropTypes.string,
};
LogoSection.propTypes = {
   name: PropTypes.string,
   value: PropTypes.any,
   onChange: PropTypes.func,
   logoType: PropTypes.func,
};

export default LogoSection;
